module.exports = __webpack_public_path__ + "static/img/megamenu-img.913183e4.png";